import { Component, OnInit, Renderer2, Inject, PLATFORM_ID, HostListener, ElementRef, ViewChild } from '@angular/core';
import 'rxjs/add/operator/filter';
import { Location } from '@angular/common';
import * as AOS from 'aos';
import { Meta } from '@angular/platform-browser';
declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
    @HostListener('window:scroll', ['$event'])
    onScroll(event: Event): void {
        $(window).on("scroll", function () {
            if ($(window).scrollTop() > 50) {
                $(".navbar-transparent").addClass("active");
            }
            if ($(window).scrollTop() < 50) {
                $(".navbar-transparent").removeClass("active");
            }
        });
    }
    constructor(private renderer : Renderer2, public location: Location, private metaTagService:Meta) {
        $("#inactive").click(function () {
			$("#inactive").removeClass("active");
			$("#inactive").addClass("active");
		});
    }
    ngOnInit() {
        AOS.init();
        this.metaTagService.addTags([
            { name: 'keywords', content: 'pixtar' },
            { name: 'robots', content: 'index, follow' },
            { name: 'author', content: 'Ipcs' },
            // { name: 'viewport', content: 'width=device-width, initial-scale=1, maximum-scale=1' }, by commenting Accessibility increased to 96%
            { name: 'viewport', content: 'width=device-width, initial-scale=1' },
            { name: 'date', content: '2022-10-1', scheme: 'YYYY-MM-DD' },
            { charset: 'UTF-8' }
          ]);
        window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
        });
    }
    removeFooter() {
        var titlee = this.location.prepareExternalUrl(this.location.path());
        titlee = titlee.slice( 1 );
        if(titlee === '/signup' || titlee === '/nucleoicons' || titlee.includes('contact') || titlee === 'p/kbn' || titlee === 'p/kbn2' || titlee === 'p/js' || titlee === 'p/io' || titlee === 'p/godly'){
            return false;
        }
        else {
            return true;
        }
    }

    removeHeader() {
        var titlee = this.location.prepareExternalUrl(this.location.path());
        titlee = titlee.slice( 1 );
        if(titlee === 'p/kbn' || titlee === 'p/kbn2' || titlee === 'p/js' || titlee === 'p/io' || titlee === 'p/godly' ){
            if ($("#botpenguin-launcher-12").hasClass("botpenguin-right")) {
                $('.BotPenguin-chat').addClass('d-none');
              }            
            return false;
        }
        else {
            return true;
        }
    }
}
